import * as yup from "yup";

export const ReqRefundSchema = yup.object().shape({
  reqFor: yup.string().required("Required"),
  name: yup.string().required("Required"),
  email: yup.string().email().required("Required"),
  contactNumber: yup.number().required("Required"),
  paymentReceipt: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    })
    .required("Required"),
  message: yup.string().required("Required"),
  reqStatus: yup.string(),
  statusFeedback: yup.string(),
  accountholderName: yup.string().required("Required"),
  bankName: yup.string().required("Required"),
  accountNumber: yup.string().required("Required"),
  ifcCode: yup.string().required("Required"),
});
